import {
  HotelPaymentRequest,
  ICreatePaymentUrlResponse,
  IPaymentSetting,
  IPaymentStatusResponse,
  IVietQRUrlRequest,
  IVietQRUrlResponse,
} from '../types/paymentTypes'
import httpClient from './httpClient'

export const createPaymentUrl = (req: HotelPaymentRequest) =>
  httpClient.post<HotelPaymentRequest, ICreatePaymentUrlResponse>('/vnpay/create_payment_url', req)

export const getPaymentStatus = (search: string) =>
  httpClient.get<IPaymentStatusResponse>(`/vnpay/verify_callback${search}`)

export const createVietQRUrl = (req: IVietQRUrlRequest) => {
  return httpClient.post<IVietQRUrlRequest, IVietQRUrlResponse>('/payment/vietqr/create_payment_url', req)
}

export const getPaymentSettings = () => httpClient.get<IPaymentSetting[]>(`/payment/settings`)
